import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Subject } from 'rxjs';
import { EstadoInfoFiviI } from 'src/app/modelos/EstadoInformacionFivi';
import { fuenteI } from 'src/app/modelos/fuentes.interface';
import { NovedadI } from 'src/app/modelos/Novedad';
import { PeriodoReporteFiviI } from 'src/app/modelos/PeriodoReporteFivi';
import { VistaAdminInfoI } from 'src/app/modelos/VistaAdminInfo';
import { VistaHistoricoNovedadesI } from 'src/app/modelos/VistaHistoricoNovedades';
import { ApiService } from 'src/app/servicios/api/api.service';
import { AppServiceService } from 'src/app/servicios/AppService.service';
import { AnalisisService } from '../../../servicios/analisis/analisis.service';
import { DataTableDirective } from 'angular-datatables';

@Component({
  selector: 'app-crearnovedadfivi',
  templateUrl: './crearnovedadfivi.component.html',
  styleUrls: ['./crearnovedadfivi.component.css']
})
export class CrearnovedadfiviComponent implements OnDestroy,OnInit {

  @ViewChild(DataTableDirective, { static: false }) dtElement: DataTableDirective;
  dtOptions: any = {};
  dtTrigger: Subject<any> = new Subject<any>();

  aniosVigen: Number[];
  PeriodoSeleccionado : PeriodoReporteFiviI = new PeriodoReporteFiviI;
  anioConsulta : Number = 0;
  consucutivoConsulta : Number = 0;

  PeriodosConsultar : PeriodoReporteFiviI[];
  PeriodoActivo : PeriodoReporteFiviI = new PeriodoReporteFiviI;
  IdPeriodoConsulta : BigInteger;
  ListaEstadosFuentes : VistaAdminInfoI[];
  Fuente : fuenteI = new fuenteI;
  PeriodoModalVer : String;
  HistricoNovedadFuente : VistaHistoricoNovedadesI[];
  page : number;
  EstadoInformacionSelectVer : EstadoInfoFiviI = new EstadoInfoFiviI;
  EstadoInformacionSelect : EstadoInfoFiviI = new EstadoInfoFiviI;
  PeriodoModalNovedad : String;
  TipoNovNueva : String = "";
  ObserNovNueva : String = "";
  BtnCrearNov : Boolean = false;
  NovedadNueva : NovedadI = new NovedadI;

  @ViewChild('openmodalconfirmar') openmodalconfirmar: ElementRef;
  @ViewChild('closemodalconfirmar') closemodalconfirmar: ElementRef;
  @ViewChild('openmodalcrearnovedad') openmodalcrearnovedad: ElementRef;
  @ViewChild('closemodalcrearnovedad') closemodalcrearnovedad: ElementRef;
  @ViewChild('openmodalvernovedad') openmodalvernovedad: ElementRef;
  @ViewChild('closemodalvernovedad') closemodalvernovedad: ElementRef;

  constructor(
    private api:ApiService,
    private router:Router,
    private toastr: ToastrService,
    private appService:AppServiceService,
    private analisisService:AnalisisService
  ) { }

  ngOnInit(): void {
    this.dtOptions = {
      pagingType: 'full_numbers',
      responsive: true,
      language:
        {
          "processing": "Procesando...",
          "lengthMenu": "Mostrar _MENU_ registros",
          "zeroRecords": "No se encontraron resultados",
          "emptyTable": "Ningún dato disponible en esta tabla",
          "infoEmpty": "Mostrando registros del 0 al 0 de un total de 0 registros",
          "infoFiltered": "(filtrado de un total de _MAX_ registros)",
          "search": "Buscar:",
          "loadingRecords": "Cargando...",
          "paginate": {
              "first": "Primero",
              "last": "Último",
              "next": "Siguiente",
              "previous": "Anterior"
          },
          "aria": {
              "sortAscending": ": Activar para ordenar la columna de manera ascendente",
              "sortDescending": ": Activar para ordenar la columna de manera descendente"
          },
          "info": "Mostrando de _START_ a _END_ de _TOTAL_ estados"
        }
    };
    this.api.listaPeriodosCalendarioFivi().subscribe(Lista1=>{
      this.PeriodosConsultar = Lista1;
    });
    this.analisisService.consultarPeriodoActivoFIVI().subscribe(PActivo=>{
      this.anioConsulta = Number(PActivo.anio);
      this.consucutivoConsulta = Number(PActivo.consecutivoPeriodo);
      this.PeriodoActivo = PActivo;
      this.IdPeriodoConsulta = PActivo.id;
      this.api.ListaEstadoInformacionFiviPorPeriodo(PActivo.id).subscribe(Lista=>{
        this.ListaEstadosFuentes = Lista;
        this.dtTrigger.next();
      });
    });
    this.analisisService.getListaAniosVigenciaFivi().subscribe(respuesta0=>{
      this.aniosVigen = respuesta0;
    });
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  RegresarAdminFivi(){
    this.router.navigate(['admininfofivi']);
  }

  peridoPorAnioMes(){
    this.analisisService.periodoFiviPorAnioMes(this.anioConsulta,this.consucutivoConsulta).subscribe(respuesta2=>{
      this.PeriodoSeleccionado = respuesta2;
      this.IdPeriodoConsulta = respuesta2.id;
      this.CosultarListaEstados(respuesta2.id);
    });
  }

  CosultarListaEstados(IdPeriodo){
    this.IdPeriodoConsulta = IdPeriodo;
    this.api.PeriodoFiviPorId(IdPeriodo).subscribe(Result2_2=>{
      this.PeriodoActivo = Result2_2;
    });
    this.api.ListaEstadoInformacionFiviPorPeriodo(IdPeriodo).subscribe(result2=>{
      this.ListaEstadosFuentes = result2;
      this.reinicializarDataTable();
    });
  }

  reinicializarDataTable(): void {
    this.dtElement.dtInstance.then((dtInstance: any) => {
      dtInstance.destroy();
      this.dtTrigger.next();
    });
  }

  ConfirmarCrearNovedad(idEstadoInformacion){
    this.openmodalconfirmar.nativeElement.click();
    this.api.ConsultarEstadoInfoFiviPorId(idEstadoInformacion).subscribe(Result3=>{
      this.EstadoInformacionSelect = Result3;
      this.api.PeriodoFiviPorId(Result3.idPeriodo.id).subscribe(Result4=>{
        this.PeriodoModalNovedad = Result4.anio+" - "+Result4.consecutivoPeriodo;
      });
      this.api.getFuenteById(Result3.idFuente.id).subscribe(Result4=>{
        this.Fuente = Result4;
      });
    });
  }

  AsignarNovedad(){
    this.TipoNovNueva = "";
    this.ObserNovNueva = "";
    this.closemodalconfirmar.nativeElement.click();
    this.openmodalcrearnovedad.nativeElement.click();
  }

  GuardarNovedad(){
    this.BtnCrearNov = true;
    let date = new Date();
    this.EstadoInformacionSelect.estado = "Cargado";
    this.EstadoInformacionSelect.novedadSis = "99 - Rinde / Novedad reportada"
    this.EstadoInformacionSelect.novedadUsu = this.TipoNovNueva;
    this.EstadoInformacionSelect.observacionFte = this.ObserNovNueva;
    this.NovedadNueva.idFte = this.Fuente.id;
    this.NovedadNueva.idUsuario = localStorage.getItem('id');
    this.NovedadNueva.idPerido = this.EstadoInformacionSelect.idPeriodo.id;
    this.NovedadNueva.fechaNov = date.getDate() + '/' + (date.getMonth()+1) + '/' + date.getFullYear();
    this.NovedadNueva.tipoNov = this.TipoNovNueva;
    this.NovedadNueva.justNov = this.ObserNovNueva;
    if(this.TipoNovNueva == ""){
      this.toastr.warning('Debe seleccionar el tipo de novedad.','Advertencia!');
      this.BtnCrearNov = false;
    }else if(this.ObserNovNueva == ""){
      this.toastr.warning('Observación corta.','Advertencia!');
      this.BtnCrearNov = false;
    }else if(this.ObserNovNueva.length < 20){
      this.toastr.warning('Observación muy corta.','Advertencia!');
      this.BtnCrearNov = false;
    }else if(this.ObserNovNueva.length > 255){
      this.toastr.warning('Observación debe tener máximo 255 caracteres.','Advertencia!');
      this.BtnCrearNov = false;
    } else {
      this.api.GuardarEstadoInformacionFivi(this.EstadoInformacionSelect).subscribe(Result5=>{
        if(Result5){
          this.api.nuevoNovedadFuente(this.NovedadNueva).subscribe(Result6=>{
            if(Result6){
              this.toastr.success('Novedad asignada.','OK!');
              this.closemodalcrearnovedad.nativeElement.click();
              this.CosultarListaEstados(this.IdPeriodoConsulta);
              this.BtnCrearNov = false;
            }
          });
        }
      }, error=> {
        this.toastr.error('Error al guardar novedad.','error!');
      });
    }
  }

  VerNovedad(idEstadoInformacion){
    this.api.ConsultarEstadoInfoFiviPorId(idEstadoInformacion).subscribe(Result7=>{
      this.EstadoInformacionSelectVer = Result7;
      this.api.PeriodoFiviPorId(Result7.idPeriodo.id).subscribe(Result4=>{
        this.PeriodoModalVer = Result4.anio+" - "+Result4.consecutivoPeriodo;
      });
      this.api.getFuenteById(Result7.idFuente.id).subscribe(Result5=>{
        this.Fuente = Result5;
      });
      this.api.ConsultarNovedadesFuentePeriodo(Result7.idFuente.id, Result7.idPeriodo.id).subscribe(Result9=>{
        this.HistricoNovedadFuente = Result9;
        this.openmodalvernovedad.nativeElement.click();
      });
    });
  }




}
